<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

defineOptions({
  name: 'dataExchangeCurrencies',
});

const store = useStore<RootState>();

// Базовый тип для сообщений с ID валюты биржи
type ExchangeCurrencyWithId = {
  idExchangeCurrency: number;
};

// Типы для WebSocket сообщений компонента exchangeCurrencies
type ExchangeCurrenciesListMessage = WebSocketMessageWithFields<'exchange-pair' | 'exchange-currency', {
  exchangeCurrencies: unknown[];
}>;
type ExchangeCurrencyNotFoundMessage = WebSocketMessageEmpty<'exchange-currency-not-found'>;
type ExchangeCurrencyAddMessage = WebSocketMessageWithFields<'exchange-currency-add' | 'exchange-currency-add-success', ExchangeCurrencyWithId & {
  idExchange: number;
  idCurrency: number;
}>;
type ExchangeCurrencyDeleteMessage = WebSocketMessageWithFields<'exchange-currency-delete' | 'exchange-currency-delete-success', ExchangeCurrencyWithId>;
type ExchangeCurrencyLockMessage = WebSocketMessageWithFields<'exchange-currency-lock' | 'exchange-currency-lock-success', ExchangeCurrencyWithId>;
type ExchangeCurrencyUnlockMessage = WebSocketMessageWithFields<'exchange-currency-unlock' | 'exchange-currency-unlock-success', ExchangeCurrencyWithId>;

// Объединенный тип для всех сообщений
type ExchangeCurrenciesWebSocketMessage = 
  | ExchangeCurrenciesListMessage 
  | ExchangeCurrencyNotFoundMessage 
  | ExchangeCurrencyAddMessage 
  | ExchangeCurrencyDeleteMessage 
  | ExchangeCurrencyLockMessage 
  | ExchangeCurrencyUnlockMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: ExchangeCurrenciesWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'exchange-pair':
    case 'exchange-currency':
      store.dispatch('exchangeCurrencies/wsSetExchangeCurrencies', { exchangeCurrencies: data.exchangeCurrencies });
      break;
    case 'exchange-currency-not-found':
      store.dispatch('exchange/wsSetEmptyExchange');
      break;
    case 'exchange-currency-add':
    case 'exchange-currency-add-success':
      store.dispatch('exchangeCurrencies/wsExchangeCurrenciesAdd', {
        idExchangeCurrency: data.idExchangeCurrency,
        idExchange: data.idExchange,
        idCurrency: data.idCurrency,
        locked: false,
      });
      break;
    case 'exchange-currency-delete':
    case 'exchange-currency-delete-success':
      store.dispatch('exchangeCurrencies/wsExchangeCurrenciesDelete', {
        idExchangeCurrency: data.idExchangeCurrency,
      });
      break;
    case 'exchange-currency-lock':
    case 'exchange-currency-lock-success':
      store.dispatch('exchangeCurrencies/wsExchangeCurrenciesLock', {
        idExchangeCurrency: data.idExchangeCurrency,
      });
      break;
    case 'exchange-currency-unlock':
    case 'exchange-currency-unlock-success':
      store.dispatch('exchangeCurrencies/wsExchangeCurrenciesUnlock', {
        idExchangeCurrency: data.idExchangeCurrency,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
